import React, { PureComponent } from "react";
import Draggable from "react-draggable";
import Button from "../Button";
import Funk from "./Funk.mp3";
import "./Window.css";

const noop = () => {};
const isEnter = e => e.key === "Enter";

const blur = () => document.activeElement && document.activeElement.blur();

export default class Window extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      zIndex: props.getZIndex(),
      minimized: false,
      value: ""
    };
  }

  static defaultProps = {
    onCancel: noop,
    onConfirm: noop,
    onChange: noop,
    onClose: noop
  };

  componentDidMount() {
    Promise.resolve(new Audio(Funk).play()).catch(e => {});
  }

  bringToFront = () => {
    this.setState(state => ({
      zIndex: this.props.getZIndex()
    }));
  };

  onMinimize = () => {
    this.setState({
      minimized: true
    });
  };

  onConfirm() {
    this.props.onConfirm(this.props.field, this.state.value);
    blur();
  }

  onChange() {
    this.props.onChange(this.props.field, this.state.value);
  }

  onCancel() {
    this.props.onCancel(this.props.field, this.state.value);
  }

  render() {
    const {
      draggable,
      title,
      children,
      onClose,
      position,
      cancel,
      confirm,
      field
    } = this.props;
    const hasActions = confirm || cancel;
    const { minimized } = this.state;

    return (
      <Draggable
        disabled={!draggable}
        handle="header"
        defaultPosition={position}
        position={!draggable ? position : undefined}
        onStart={this.bringToFront}
      >
        <div
          className={`window share ui-draggable windows-vis ${minimized &&
            "minimized"}`}
          style={{ zIndex: this.state.zIndex }}
          onMouseDown={this.bringToFront}
        >
          <header>
            <nav className="control-window">
              <a onClick={onClose} className="close">
                close
              </a>
              <a onClick={onClose} className="minimize">
                minimize
              </a>
              <a onClick={onClose} className="maximize">
                maximize
              </a>
            </nav>
            <h1 className="titleInside">{title}</h1>
          </header>
          <div className="container">
            <div className="container-inside">
              {children}
              {field && (
                <form onSubmit={e => e.preventDefault()}>
                  <input
                    autoFocus
                    type="text"
                    value={this.state.value}
                    onChange={e => {
                      this.setState({ value: e.target.value }, () => {
                        this.onChange();
                      });
                    }}
                    onKeyPress={e => {
                      isEnter(e) && this.onConfirm();
                    }}
                  />
                </form>
              )}
            </div>
            <div className={`actions ${!hasActions && "invisible"}`}>
              {cancel && (
                <Button onClick={() => this.onCancel()}>{cancel}</Button>
              )}{" "}
              <Button onClick={() => this.onConfirm()}>{confirm}</Button>
            </div>
          </div>
        </div>
      </Draggable>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Window/Window.js